// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__PfSsJ","spacer":"layout_spacer__B1MDK","legal":"layout_legal__BKvgz"};